export default __webpack_public_path__ + "static/73-3c96f68be4356826f7544714d8d3fda8.png";